import { render } from "./SlasDetails.vue?vue&type=template&id=506e3957&scoped=true"
import script from "./SlasDetails.vue?vue&type=script&lang=js"
export * from "./SlasDetails.vue?vue&type=script&lang=js"

import "./SlasDetails.vue?vue&type=style&index=0&id=506e3957&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506e3957"]])

export default __exports__